export interface Column1ViewModelState {
  genericDocJournalListingState: any;
  }
  
  export const initialState: Column1ViewModelState = {
  genericDocJournalListingState: null,
  };